module.exports = __webpack_public_path__ + "assets/img/6-small.c9b47a98.png";